export const onSetApps = (app_ids) => ({
  type: 'SET_APPS',
  app_ids
})

export const onToggleApp = (app_id) => ({
  type: 'TOGGLE_APP',
  app_id
})